import { useEffect, useState } from "react";
import { BellRing, ChevronDown, ChevronUp, Mail } from "lucide-react";
import { adminApi } from "@/lib/api";

const daysAgo = (iso) => (iso ? Math.floor((Date.now() - new Date(iso).getTime()) / 86400000) : 0);

export const FollowupWidget = ({ onFollowup, refreshKey }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  const load = () => {
    adminApi.followups().then(setData).catch(() => {});
  };
  useEffect(load, [refreshKey]);

  const leads = data?.leads || [];
  return (
    <div data-testid="followup-widget" className="border border-[#d5dbde] bg-white">
      <button data-testid="followup-widget-toggle" onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-4 px-5 py-4 text-left hover:bg-[#f4f6f7] transition-colors">
        <div className={`w-9 h-9 flex items-center justify-center ${leads.length ? "bg-[#3b82f6]/15 text-[#3b82f6]" : "bg-[#f4f6f7] text-[#52525b]"}`}>
          <BellRing className="w-4 h-4" />
        </div>
        <div className="mr-auto">
          <div className="text-sm text-[#2B3036]">
            <span data-testid="followup-count" className="font-display text-xl mr-1.5">{leads.length}</span>
            lead da ricontattare oggi
          </div>
          <div className="text-[11px] text-[#6b7280]">Stato "contattato" da più di {data?.days ?? 5} giorni · riepilogo email ogni mattina alle 8:00</div>
        </div>
        {leads.length > 0 && (
          <span onClick={(e) => { e.stopPropagation(); onFollowup(leads.filter((l) => l.email)); }}
            data-testid="followup-send-all" role="button"
            className="aurora-gradient text-white text-xs px-3 py-2 inline-flex items-center gap-1.5 hover:opacity-90">
            <Mail className="w-3.5 h-3.5" /> Follow-up a tutti
          </span>
        )}
        {open ? <ChevronUp className="w-4 h-4 text-[#6b7280]" /> : <ChevronDown className="w-4 h-4 text-[#6b7280]" />}
      </button>

      {open && (
        <div data-testid="followup-list" className="border-t border-[#d5dbde] max-h-72 overflow-y-auto">
          {leads.map((l) => (
            <div key={l.id} className="flex items-center gap-4 px-5 py-3 border-b border-[#e9edef] last:border-0">
              <div className="min-w-0 mr-auto">
                <div className="text-sm text-[#2B3036] truncate">{l.company_name}</div>
                <div className="text-[11px] font-mono text-[#6b7280] truncate">{l.city} · {l.email || l.phone}</div>
                {l.crm_note && <div className="text-[11px] text-[#f59e0b] truncate">{l.crm_note}</div>}
              </div>
              <span className="text-[10px] font-mono text-[#3b82f6] uppercase whitespace-nowrap">{daysAgo(l.last_contact_at)} gg fa</span>
              <button data-testid={`followup-send-${l.id}`} onClick={() => onFollowup([l])} disabled={!l.email}
                className="border border-[#d5dbde] hover:border-[#E0262C] px-3 py-1.5 text-xs text-[#2B3036] disabled:opacity-30">
                Follow-up
              </button>
            </div>
          ))}
          {!leads.length && <div className="px-5 py-8 text-center text-xs font-mono text-[#6b7280]">Nessun lead in attesa di follow-up</div>}
        </div>
      )}

    </div>
  );
};
